import type { MouseEvent } from "react";
import { useCallback, useRef, useState } from "react";
import type { SwiperRef } from "swiper/react";

export function useCarousel() {
  const swiperReference = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = useCallback(() => {
    if (!swiperReference.current) return;
    setActiveIndex(swiperReference.current.swiper.activeIndex);
  }, []);

  const handlePrevious = useCallback((event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    swiperReference.current?.swiper.slidePrev();
  }, []);

  const handleNext = useCallback((event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    swiperReference.current?.swiper.slideNext();
  }, []);

  const handleDotClick = useCallback((event: MouseEvent, index: number) => {
    event.stopPropagation();
    event.preventDefault();
    swiperReference.current?.swiper.slideTo(index);
  }, []);

  return {
    activeIndex,
    handleDotClick,
    handleNext,
    handlePrevious,
    handleSlideChange,
    swiperReference,
  };
}
